let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("1k16i")]).then(() => parcelRequire('gHrFG'));